import React from 'react';
import classNames from 'classnames';
import propTypes from 'prop-types';

import { getMessage } from 'util/locale';
import { convertForLocale } from 'util/unitConversion';
import { unitValue } from 'constants/types';

const baseString = 'vra-harvest-history-table--data-type';
const classString = classNames({
  [`${baseString}`]: true
});

const DataType = ({
  averageYield,
  cropNominalWeight,
  layerType,
  season
}) => {
  const averageYieldText = !!averageYield && !!cropNominalWeight
    ? (
      <div className={`${baseString}__avg-yield`}>
        {convertForLocale({
          quantity: averageYield.q,
          unit: averageYield.u,
          unitType: 'area-density.yield',
          cropNominalWeight: cropNominalWeight
        }).toString()}
      </div>
    )
    : null;
  const layerTypeText = getMessage(`label-text__layer-type--${layerType}`);
  return (
    <section className={classString}>
      <div>{`${season.substr(0,4)} ${layerTypeText}`}</div>
      {averageYieldText}
    </section>
  );
};

DataType.propTypes = {
  averageYield: unitValue,
  cropNominalWeight: propTypes.number,
  layerType: propTypes.string.isRequired,
  season: propTypes.string.isRequired
};

export default DataType;
